import MainLayout from '@/components/layout/MainLayout.vue';
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';
import AssignmentAnswerList from "@/components/assignment/answer/AssignmentAnswerList.vue";
import CreateAssignmentAnswer from "@/components/assignment/answer/CreateAssignmentAnswer.vue";
import EditAssignmentAnswer from "@/components/assignment/answer/EditAssignmentAnswer.vue";
import DetailAssignmentAnswer from "@/components/assignment/answer/DetailAssignmentAnswer.vue";
import AssignmentAnswerRemark from "@/components/assignment/answer/AssignmentAnswerRemark.vue";

export default {
  name: "detailStudentAssignment",

  components: {
    MainLayout,
    CreateAssignmentAnswer,
    AssignmentAnswerList,
    EditAssignmentAnswer,
    DetailAssignmentAnswer,
    AssignmentAnswerRemark
  },

  data() {
    return {
      assignment: {},
      currentTab: "detail",
      tabs: ["detail", "answer"],
      pdfIcon,
      docIcon,
      pptIcon,
      curSection: 'AssignmentAnswerList',
      answerId: null
    };
  },

  computed: {
    ...mapGetters(["teacherId", "studentId", "userType"]),
  },

  methods: {
    assignmentDetail() {
      axios.get("my/assignment/detail/" + this.$route.params.id)
        .then(response => {
          this.assignment = response.data;
          this.assignment.assignment_files.forEach(file => {
            file.type = file.name.split('.')[1];
          });
        })
        .catch((error) => {
          if (error.response.status == 404) {
            this.$router.replace({
              name: 'notFound'
            });
          }

          if (error.response.status == 403) {
            this.$router.push({
              name: 'forbidden'
            });
          }

          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Assignment Detail API Error:", error);
        });
    },

    changeSection(section, answerId) {
      if (answerId) {
        this.answerId = answerId;
      }
      this.curSection = section;
    },

    tabChange(tab) {
      if (tab === "detail") {
        this.curSection = "AssignmentAnswerList";
      }
      this.currentTab = tab;
    },

    async download(index) {
      var file = this.assignment.assignment_files[index];
      try {
        const response = await axios.get(`my/assignment/download/${this.$route.params.id}/${file.file_code}`, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.name;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        this.$notification.error("Download Failed.", {
          timer: 3,
          position: "bottomCenter",
        });
      }
    }
  },

  filters: {
    setMoment: function (date) {
      return moment(date).format("DD MMMM YYYY");
    }
  },

  mounted() {
    this.assignmentDetail();
  }
};
